// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.xOIvBb {
  padding: 28px 0 24px;
  font-family: var(--font-family-base);
  --text-primary-medium: #d64000;
  --surface-primary-medium: #d64000;
  --surface-primary-subtle: #ffeee5;
  --breadcrumb-initial-color: #d64000;
  --breadcrumb-font-size: 14px;
  --breadcrumb-font-weight: 600;
  --breadcrumb-line-height: 20px;
}
/* Hidden horizontal overflow creates nested scroll containers that prevent the
   migration confirmation from sticking to the document viewport. */
main:has(.xOIvBb),
div:has(.xOIvBb) {
  overflow-x: clip;
  overflow-y: visible;
}
.OxgCDX {
  color: var(--text-neutral-dark);
}
.QgUGmb {
  display: grid;
  grid-template-columns: minmax(0, 733fr) minmax(0, 355fr);
  gap: var(--spacing-3);
  align-items: start;
}
.zeiKcz {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-3);
  min-width: 0;
}
@media (max-width: 1023px) {
  .QgUGmb {
    grid-template-columns: 1fr;
  }
}
`, "",{"version":3,"sources":["webpack://./../../packages/beneficios/src/pages/BenefitMigrationPage/BenefitMigrationPage.module.css"],"names":[],"mappings":"AAAA;EACE,oBAAoB;EACpB,oCAAoC;EACpC,8BAA8B;EAC9B,iCAAiC;EACjC,iCAAiC;EACjC,mCAAmC;EACnC,4BAA4B;EAC5B,6BAA6B;EAC7B,8BAA8B;AAChC;AACA;mEACmE;AACnE;;EAEE,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,+BAA+B;AACjC;AACA;EACE,aAAa;EACb,wDAAwD;EACxD,qBAAqB;EACrB,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,YAAY;AACd;AACA;EACE;IACE,0BAA0B;EAC5B;AACF","sourcesContent":[".layout {\n  padding: 28px 0 24px;\n  font-family: var(--font-family-base);\n  --text-primary-medium: #d64000;\n  --surface-primary-medium: #d64000;\n  --surface-primary-subtle: #ffeee5;\n  --breadcrumb-initial-color: #d64000;\n  --breadcrumb-font-size: 14px;\n  --breadcrumb-font-weight: 600;\n  --breadcrumb-line-height: 20px;\n}\n/* Hidden horizontal overflow creates nested scroll containers that prevent the\n   migration confirmation from sticking to the document viewport. */\n:global(main):has(.layout),\n:global(div):has(.layout) {\n  overflow-x: clip;\n  overflow-y: visible;\n}\n.container {\n  color: var(--text-neutral-dark);\n}\n.columns {\n  display: grid;\n  grid-template-columns: minmax(0, 733fr) minmax(0, 355fr);\n  gap: var(--spacing-3);\n  align-items: start;\n}\n.main {\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-3);\n  min-width: 0;\n}\n@media (max-width: 1023px) {\n  .columns {\n    grid-template-columns: 1fr;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"layout": `xOIvBb`,
	"container": `OxgCDX`,
	"columns": `QgUGmb`,
	"main": `zeiKcz`
};
module.exports = ___CSS_LOADER_EXPORT___;
